import React from "react";
import AllGoodsReceipts from "./GoodsReceiptModule/AllGoodsReceipts";

const GoodsReceipts = () => {
  return (
    <div>
      <AllGoodsReceipts />
    </div>
  );
};

export default GoodsReceipts;
